import React , {Component} from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { syncExam } from '../../actions';
import styled from 'styled-components';
//import LogoImg from './examiner_logo.png';
import CorpLogoImg from '../../assets/img/rh_logo.png';
import NormalImg from '../common/Img';
import Button from '../common/Button';
//import isEmpty from 'lodash/isEmpty';

const ButtonA = styled(Button)`
  background: #324971;
  color: #fff;
`;

const RhLogo = styled(NormalImg)`
  width: 150px;
  margin: 300px auto 20px auto;
  display: block;
`;



class SyncArea extends Component {

  

  state = {
        examNumber: null,
        bicamsNumber: null
    }

  constructor(props){
    super(props);
    this.state = {
      //participantId: '',
      errors: {},
      //exam: {},
      syncDone: false,
      globalError: '',
      examNumber: this.props.exams.exam.ExamNumber,
      bicamsNumber:  this.props.exams.exam.ParticipantBicamsNumber
    };
    
    this.handleSync = this.handleSync.bind(this);

    console.log(this.props.exams); 
    
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      //examNumber: 0,
      //bicamsNumber: 0,
      errors: {},
     // exam: {},
      syncDone: false,
    });
  }

  handleSync(e) {
    e.preventDefault();
    
    this.props.syncExam().then(
                (res) => this.setState({ syncDone: true, examNumber: res.exam.ExamNumber, exam: res.exam, bicamsNumber: res.exam.ParticipantBicamsNumber  }),
                (err) => this.setState({ globalError: "Could not start new exam", done: false })
            );
    console.log(this.state.examNumber);
  }

  render() {
    const startButton = (
      <div className="row">
        <div className="col-md-6 col-md-offset-3 text-center">
            <p>Check participant has their reading glasses on</p>
          <Link to="/acuity_test"><ButtonA className="btn btn-lg">Start Acuity Test</ButtonA></Link>
          <br /> 
          <p>BICAMS No {this.state.bicamsNumber}<br/>
          Exam No {this.state.examNumber}
          </p>    

          <RhLogo src={CorpLogoImg} alt="Royal Holloway Logo" />
        </div>
      </div>
    );
    const loading = (
      <div className="row">
        <div className="col-md-6 col-md-offset-3 text-center">
          <Button onClick={this.handleSync}>Sync <span>N: {this.state.examNumber}</span>
          </Button>

            <p><strong>Awaiting link with participant iPad</strong></p>
            <p>Open BICAMS Participant App and login</p>

            <br />
          <p>BICAMS No {this.state.bicamsNumber}<br/>
          Exam No {this.state.examNumber}
          </p> 

          <RhLogo src={CorpLogoImg} alt="Royal Holloway Logo" />
        </div>
      </div>
    );
    return (
      <div className="row">
        <div className="col-md-4 col-md-offset-4">
          {this.state.syncDone ? startButton : loading}
        </div>
      </div>
    );
  }
}

SyncArea.propTypes = {
  syncExam: React.PropTypes.func.isRequired
}

function mapStateToProps(state) {
    return {
      exams: state.exams
    }
}

export default connect(mapStateToProps, { syncExam })(SyncArea);





// WEBPACK FOOTER //
// ./src/components/exam/SyncArea.js